import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const coreDataForm: Form<Client> = {
  key: 'coreData',
  title: 'Stammdaten',
  fields: [
    {
      key: 'name',
      label: 'Name',
      fieldTypes: 'text',
    },
    {
      key: 'address',
      label: 'Anschrift',
      fieldTypes: 'text',
    },
    {
      key: 'phone',
      label: 'Telefon',
      fieldTypes: 'text',
    },
    {
      key: 'email',
      label: 'E-Mail',
      fieldTypes: 'text',
    },
    {
      key: 'gender',
      label: 'Geschlecht',
      fieldTypes: 'select',
      options: [
        {
          value: 'female',
          label: 'weiblich',
        },
        {
          value: 'male',
          label: 'männlich',
        },
        {
          value: 'diverse',
          label: 'divers',
        },
      ],
    },
    {
      key: 'isUnderEighteen',
      label: 'Jugendliche Person',
      fieldTypes: 'checkbox',
    },
    {
      key: 'age',
      label: 'Alter',
      fieldTypes: 'select',
      chart: {
        type: 'bar',
        heading: 'Alter der Betroffenen',
      },
      options: [
        {
          value: 'underTwelve',
          label: 'Unter 12 Jahre',
        },
        {
          value: 'thirteen',
          label: '13 Jahre',
        },
        {
          value: 'fourteen',
          label: '14 Jahre',
        },
        {
          value: 'fifteen',
          label: '15 Jahre',
        },
        {
          value: 'sixteen',
          label: '16 Jahre',
        },
        {
          value: 'seventeen',
          label: '17 Jahre',
        },
        {
          value: 'eighteenTillTwentyone',
          label: '18 - 21 Jahre',
        },
        {
          value: 'twentytwoTillThirty',
          label: '22 - 30 Jahre',
        },
        {
          value: 'thirtyoneTillFourtyfive',
          label: '31 - 45 Jahre',
        },
        {
          value: 'fourtysixTillFivtyfive',
          label: '46 - 55 Jahre',
        },
        {
          value: 'overFivtysix',
          label: 'Über 56 Jahre',
        },
      ],
    },
    {
      key: 'exactAge',
      label: 'Genaues Alter',
      fieldTypes: 'text',
      isVisible: (client) =>
        client.age != null &&
        (client.age === 'underTwelve' ||
          client.age === 'eighteenTillTwentyone' ||
          client.age === 'twentytwoTillThirty' ||
          client.age === 'thirtyoneTillFourtyfive' ||
          client.age === 'fourtysixTillFivtyfive' ||
          client.age === 'overFivtysix'),
    },
    {
      key: 'location',
      label: 'Ort',
      fieldTypes: 'select',
      chart: {
        type: 'pie',
        heading: 'Einzugsgebiet',
      },
      options: [
        {
          value: 'nuremberg',
          label: 'Nürnberg Stadt',
        },
        {
          value: 'middleFranconia',
          label: 'Mittelfranken',
        },
        {
          value: 'otherDistricts',
          label: 'Andere Bezirke',
        },
        {
          value: 'outsideOfBavaria',
          label: 'Außerhalb Bayern',
        },
      ],
    },
    {
      key: 'personType',
      label: 'Der/Die Anrufer*in ist',
      fieldTypes: 'select',
      chart: {
        type: 'pie',
        heading: 'Zielgruppen',
        options: [
          { label: 'Betroffene', keys: ['personAffectedFemale', 'personAffectedMale', 'personAffectedDiverse'] },
          { label: 'Angehörige', keys: ['relatives', 'partner'] },
          { label: 'Multiplikator*innen', keys: ['multiplier'] },
          { label: 'Freund*innen/Kolleg*innen', keys: ['otherPerson'] },
          { label: 'k. A.', keys: ['notSpecified'] },
        ],
      },
      options: [
        {
          value: 'personAffectedFemale',
          label: 'Betroffene weiblich',
        },
        {
          value: 'personAffectedMale',
          label: 'Betroffener männlich',
        },
        {
          value: 'personAffectedDiverse',
          label: 'Betroffene Person divers',
        },
        {
          value: 'relatives',
          label: 'Familienangehörige*r',
        },
        {
          value: 'partner',
          label: '(Ehe-) Partner*in',
        },
        {
          value: 'otherPerson',
          label: 'sonstige Person',
        },
        {
          value: 'multiplier',
          label: 'Multiplikator*innen',
        },
      ],
    },
    {
      key: 'relationship',
      label: 'Verwandschaftsbeziehung',
      fieldTypes: 'select',
      isVisible: (client) => client.personType != null && client.personType === 'relatives',
      options: [
        {
          value: 'mother',
          label: 'Mutter',
        },
        {
          value: 'father',
          label: 'Vater',
        },
        {
          value: 'parents',
          label: 'Eltern',
        },
        {
          value: 'other',
          label: 'Andere',
        },
      ],
    },
    {
      key: 'otherRelationship',
      label: 'Andere Verwandschaftsbeziehung',
      fieldTypes: 'text',
      isVisible: (client) =>
        client.personType != null &&
        client.personType === 'relatives' &&
        client.relationship != null &&
        client.relationship === 'other',
    },
    {
      key: 'otherPerson',
      label: 'Sonstige Person',
      fieldTypes: 'text',
      isVisible: (client) => client.personType != null && client.personType === 'otherPerson',
    },
    {
      key: 'profession',
      label: 'Beruf / Funktion',
      fieldTypes: 'text',
      isVisible: (client) => client.personType != null && client.personType === 'multiplier',
    },
    {
      key: 'note',
      label: 'Kommentar',
      fieldTypes: 'textArea',
      xsWidth: 12,
    },
  ],
};

export default coreDataForm;
